
import RcObject from "@/domain/common/RcObject.js";

export default class LabelListFilter extends RcObject {

  static Fields = {
    PAGINATION: 'pagination',
    COMPANY: "Company",
    SEARCH_TEXT: 'searchText',
    SORT_BY: "sortBy",
    STATE_TYPE: 'state',
  }

  constructor() {
    super({});
  }

  withCompany(companyId) {
    this.put(LabelListFilter.Fields.COMPANY, companyId);
    return this;
  }

  withStateActive() {
    return this.withState("active");
  }

  withState(state) {
    this.put(LabelListFilter.Fields.STATE_TYPE, state);
    return this;
  }

  withPagination(size, number) {
    this.put(LabelListFilter.Fields.PAGINATION, { size, number });
    return this;
  }

  withSearchText(text) {
    this.put(LabelListFilter.Fields.SEARCH_TEXT, { 'text': text });
    return this;
  }

  withSortBy(sortBy) {
    let direction = "asc";

    let newValue = sortBy.replace("Az", "");
    if (newValue.length < sortBy.length) {
      direction = "asc";
      this.put(LabelListFilter.Fields.SORT_BY, { 'value': newValue, 'dir': direction });
    }

    newValue = sortBy.replace("Za", "");
    if (newValue.length < sortBy.length) {
      direction = "des";
      this.put(LabelListFilter.Fields.SORT_BY, { 'value': newValue, 'dir': direction });
    }
    return this;
  }

  done() {
    //
  }
}